import { useState } from 'react';
import { Link } from 'react-router-dom';

const CDN = "https://cdn.prod.website-files.com/602f5458a0b1d868c6c84d5b";

export default function Footer() {
  const [formData, setFormData] = useState({
    email: "",
    phone: "+1",
    number: "",
    message: "",
  });
  const [submitted, setSubmitted] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    try {
      fetch("https://hooks.zapier.com/hooks/catch/26061763/uly2wza/", {
        method: "POST",
        mode: "no-cors",
        body: JSON.stringify({
          payload: {
            name: "docstrange_footer_form",
            data: {
              email: formData.email,
              company: "NA",
              name: formData.phone + formData.number,
              requirement: formData.message,
            },
          },
        }),
      });
      setSubmitted(true);
    } catch {
      // fail silently
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <footer className="relative bg-[#080B1A] overflow-hidden">
      {/* Background glows */}
      <div className="pointer-events-none absolute inset-0">
        <div className="absolute -top-32 -left-32 w-[500px] h-[500px] rounded-full bg-[#546FFF] opacity-[0.12] blur-[120px]" />
        <div className="absolute bottom-0 right-0 w-[400px] h-[400px] rounded-full bg-[#7B93FF] opacity-[0.08] blur-[100px]" />
      </div>

      {/* CTA form band */}
      <div className="relative border-b border-[#ffffff0f]">
        <div className="max-w-[1200px] mx-auto px-6 py-16">
          <div className="flex flex-col md:flex-row gap-12">
            {/* Left - heading */}
            <div className="flex flex-col gap-3">
              <p className="text-[#546FFF] text-sm font-semibold tracking-widest uppercase">
                GET IN TOUCH
              </p>
              <h2 className="text-3xl font-bold text-white">
                Have more questions?
              </h2>
            </div>

            {/* Center - form */}
            <div className="flex-1 max-w-[420px]">
              {submitted ? (
                <div className="p-6 bg-[#546FFF1A] rounded-2xl border border-[#546FFF33] text-center">
                  <p className="text-white font-medium mb-2">
                    Successful! We will reach out to you over the provided email shortly.
                  </p>
                  <button
                    onClick={() => setSubmitted(false)}
                    className="text-[#546FFF] underline text-sm"
                  >
                    Submit another query
                  </button>
                </div>
              ) : (
                <>
                  <h4 className="font-bold text-white mb-4">Send in a query</h4>
                  <form onSubmit={handleSubmit} className="flex flex-col gap-3">
                    <input
                      type="email"
                      placeholder="Your work email*"
                      required
                      value={formData.email}
                      onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                      className="w-full px-4 py-3 bg-[#ffffff0d] border border-[#ffffff18] rounded-lg text-sm text-white placeholder:text-[#ffffff44] focus:outline-none focus:border-[#546FFF]"
                    />
                    <div className="flex gap-2">
                      <input
                        type="tel"
                        placeholder="+1"
                        value={formData.phone}
                        onChange={(e) => setFormData({ ...formData, phone: e.target.value })}
                        className="w-20 px-3 py-3 bg-[#ffffff0d] border border-[#ffffff18] rounded-lg text-sm text-white placeholder:text-[#ffffff44] focus:outline-none focus:border-[#546FFF]"
                      />
                      <input
                        type="tel"
                        placeholder="Contact number"
                        value={formData.number}
                        onChange={(e) => setFormData({ ...formData, number: e.target.value })}
                        className="flex-1 px-4 py-3 bg-[#ffffff0d] border border-[#ffffff18] rounded-lg text-sm text-white placeholder:text-[#ffffff44] focus:outline-none focus:border-[#546FFF]"
                      />
                    </div>
                    <textarea
                      placeholder="How can we help you?*"
                      required
                      rows={4}
                      value={formData.message}
                      onChange={(e) => setFormData({ ...formData, message: e.target.value })}
                      className="w-full px-4 py-3 bg-[#ffffff0d] border border-[#ffffff18] rounded-lg text-sm text-white placeholder:text-[#ffffff44] focus:outline-none focus:border-[#546FFF] resize-none"
                    />
                    <button
                      type="submit"
                      disabled={submitting}
                      className="px-6 py-3 bg-[#546FFF] text-white rounded-lg font-medium text-sm hover:bg-[#3A4DB2] transition-colors disabled:opacity-60 self-start cursor-pointer"
                    >
                      {submitting ? "Sending..." : "Submit Query"}
                    </button>
                  </form>
                </>
              )}
            </div>

            {/* Divider */}
            <div className="hidden md:block w-px bg-[#ffffff15]" />

            {/* Right - talk to expert */}
            <div className="flex-shrink-0 max-w-[280px] flex flex-col gap-4">
              <h4 className="font-bold text-white">Talk to an AI expert</h4>
              <p className="text-[#ffffff88] text-sm leading-relaxed">
                Get a free 15-minute consultation with our Automation experts. We can discuss
                Pricing, Integrations or try the app live on your own documents.
              </p>
              <Link
                to="/demo"
                className="inline-flex items-center gap-2 px-5 py-3 bg-[#546FFF] text-white rounded-lg font-medium text-sm hover:bg-[#3A4DB2] transition-colors"
              >
                Request a Demo
                <img
                  src={`${CDN}/63513b2edb7161e5a02a2f64_cta-people.webp`}
                  alt=""
                  className="h-6 w-auto"
                />
              </Link>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom nav bar */}
      <div className="relative">
        <div className="max-w-[1200px] mx-auto px-6 py-10">
          <div className="flex flex-col md:flex-row gap-10 md:gap-16">
            {/* Logo */}
            <div className="flex-shrink-0">
              <a href="https://nanonets.com/">
                <img
                  src={`${CDN}/60308d571fd45c78efae77c3_logo-white.svg`}
                  alt="Nanonets logo"
                  width={137}
                  height={30}
                />
              </a>
            </div>

            {/* Nav columns */}
            <div className="flex flex-wrap gap-10 flex-1 justify-center">
              {/* Resources */}
              <div className="flex flex-col gap-3">
                <h6 className="text-[#ffffff66] text-xs font-semibold uppercase tracking-widest">
                  Resources
                </h6>
                <div className="flex flex-col gap-2">
                  <a href="https://docstrange.nanonets.com/docs" className="text-[#ffffffcc] text-sm hover:text-white transition-colors">API Documentation</a>
                  <a href="https://idp-leaderboard.org/" target="_blank" rel="noopener noreferrer" className="text-[#ffffffcc] text-sm hover:text-white transition-colors">IDP Benchmark Leaderboard</a>
                  <a href="https://nanonets.com/blog/" className="text-[#ffffffcc] text-sm hover:text-white transition-colors">Blog</a>
                  <a href="https://nanonets.com/partnerships" className="text-[#ffffffcc] text-sm hover:text-white transition-colors">Partners</a>
                </div>
              </div>

              {/* Company */}
              <div className="flex flex-col gap-3">
                <h6 className="text-[#ffffff66] text-xs font-semibold uppercase tracking-widest">
                  Company
                </h6>
                <div className="flex flex-col gap-2">
                  <a href="https://nanonets.com/about" className="text-[#ffffffcc] text-sm hover:text-white transition-colors">About</a>
                  <a href="https://nanonets.com/about" className="text-[#ffffffcc] text-sm hover:text-white transition-colors">Investors</a>
                  <a href="https://nanonets.com/career" className="text-[#ffffffcc] text-sm hover:text-white transition-colors">Careers</a>
                  <a href="https://legal.nanonets.com/privacy" className="text-[#ffffffcc] text-sm hover:text-white transition-colors">Privacy policy</a>
                  <a href="https://legal.nanonets.com/terms" className="text-[#ffffffcc] text-sm hover:text-white transition-colors">Terms of Service</a>
                </div>
              </div>

              {/* Get in touch */}
              <div className="flex flex-col gap-3">
                <h6 className="text-[#ffffff66] text-xs font-semibold uppercase tracking-widest">
                  Get in touch
                </h6>
                <div className="flex flex-col gap-2">
                  <a href="tel:+16503828676" className="text-[#ffffffcc] text-sm hover:text-white transition-colors">+1 650 382 8676</a>
                  <a href="mailto:info@nanonets.com" className="text-[#ffffffcc] text-sm hover:text-white transition-colors">info@nanonets.com</a>
                  <p className="text-[#ffffffcc] text-sm">156 2nd Street, San Francisco, CA 94105, USA</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
